export default "__VITE_ASSET__C3j0h7MR__"